import moment from "moment";
import * as yup from "yup";

import {
  DATE_OF_IRB_SUBMISSION,
  DEPARTMENT,
  DEPARTMENT_OTHERS,
  DOCUMENTS,
  EMAILS,
  FUND_TYPE,
  IRB_PRESENTATION,
  IS_EDITABLE,
  IS_FUNDED,
  IS_INPUT_OPENED,
  IS_TERMS_ACCEPTED,
  LABEL,
  PRINCIPAL_INVESTIGATOR,
  PRINCIPAL_INVESTIGATOR_OTHERS,
  PROTOCOL_NUMBER,
  REQUIRED,
  SPONSOR,
  SPONSOR_OTHERS,
  STUDY_PHASE,
  STUDY_PHASE_OTHER,
  TITLE,
  TYPE_OF_PV_PD,
  TYPE_OF_STUDY,
  TYPE_OF_STUDY_OTHER,
  _URL
} from "../../../../constants/forms";

export const irbDocumentsInitData = [
  {
    [LABEL]: "Cover letter",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "Protocol ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "English ICD/ICD waiver ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "CV ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "GCP ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "Investigator Undertaking ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "MRC ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "IB/publication support/ Device Manuals/Package Insert ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
  {
    [LABEL]: "Protocol Signature Sheet ",
    [REQUIRED]: true,
    [_URL]: "",
    [IS_EDITABLE]: false,
    [IS_INPUT_OPENED]: false,
  },
];

export const createIRBInitData = {
  [IRB_PRESENTATION]: "",
  [DATE_OF_IRB_SUBMISSION]: moment().format("yyyy-MM-DD"),
  [DEPARTMENT]: "",
  [DEPARTMENT_OTHERS]: "",
  [EMAILS]: ["user1@gmail.com"],
  [FUND_TYPE]: "",
  [IS_FUNDED]: false,
  [IS_TERMS_ACCEPTED]: false,
  [PRINCIPAL_INVESTIGATOR]: "",
  [PRINCIPAL_INVESTIGATOR_OTHERS]: "",
  [PROTOCOL_NUMBER]: "",
  [SPONSOR]: "",
  [SPONSOR_OTHERS]: "",
  [STUDY_PHASE]: "",
  [STUDY_PHASE_OTHER]: "",
  [TITLE]: "",
  [TYPE_OF_STUDY]: "",
  [TYPE_OF_STUDY_OTHER]: "",
  [TYPE_OF_PV_PD]: "",
  [DOCUMENTS]: irbDocumentsInitData,
};

const studyDetailsStepValidation = yup.object().shape({
  [PROTOCOL_NUMBER]: yup.string().required("Protocol is required"),
  [TITLE]: yup.string().required("Study title is required"),
  [SPONSOR]: yup.string().required("Sponsor name is required"),
  [PRINCIPAL_INVESTIGATOR]: yup
    .string()
    .required("Principal investigator name is required"),

  [DEPARTMENT]: yup.string().required("Department is required"),
  [EMAILS]: yup
    .array()
    .of(yup.string())
    .min(1, "Please add training")
    .required("Emails are required"),
  [STUDY_PHASE]: yup.string().required("Study phase is required"),
  [TYPE_OF_STUDY]: yup.string().required("Types of study is required"),
  [IS_FUNDED]: yup.boolean().required("This is required"),
  [FUND_TYPE]: yup.string().when("isFunded", {
    is: true,
    then: yup.string().required("Fund type is required"),
  }),
  [IS_TERMS_ACCEPTED]: yup
    .boolean()
    .isTrue("Please accept the terms first.")
    .required("Please accept the terms first."),
});

const irbSubmissionStepValidation = yup.object().shape({
  [DATE_OF_IRB_SUBMISSION]: yup
    .date()
    .required("Date of MIRB submission is required "),
  [DOCUMENTS]: yup
    .array()
    .of(
      yup.object().shape({
        [LABEL]: yup.string().required("Label is required"),
        [REQUIRED]: yup.boolean().required(),
        [_URL]: yup.string().when(REQUIRED, {
          is: true,
          then: yup.string().test(_URL, function (value) {
            const label = this.parent[LABEL] || "";
            return (
              Boolean(value) ||
              this.createError({ message: `Please add ${label} document` })
            );
          }),
          otherwise: yup.string(),
        }),
      })
    )
    .required("At least one document is required")
    .min(1),
  [IRB_PRESENTATION]: yup.string().required("This document is required"),
});

export const IRBSubmissionValidationSchema = [
  studyDetailsStepValidation,
  irbSubmissionStepValidation,
];
